import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPopularJobCategoriesList } from "./PopularJobCategoriesListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPopularJobCategoriesListAsync = createAsyncThunk(
  "PopularJobCategoriesList/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchPopularJobCategoriesList(uuid);

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return {
        jobs: resp.data,  // The array of job data
        totalJobs: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PopularJobCategoriesListSlice = createSlice({
  name: "PopularJobCategoriesList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPopularJobCategoriesListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPopularJobCategoriesListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
        // console.log("data api", action.payload);
        state.error = null;
      })
      .addCase(fetchPopularJobCategoriesListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});
 
export const selectPopularJobCategoriesList = (state) => state.popularJobCategoriesList.data.jobs;
export const selectPopularJobCategoriesTotal = (state) => state.popularJobCategoriesList.data.totalJobs;


export default PopularJobCategoriesListSlice.reducer;
